module.exports = __webpack_public_path__ + "img/f-thermometer-img8-2.26ab1f9b.png";